import { render, staticRenderFns } from "./w2d.vue?vue&type=template&id=e544d26e&"
import script from "./w2d.vue?vue&type=script&lang=js&"
export * from "./w2d.vue?vue&type=script&lang=js&"
import style0 from "./w2d.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e544d26e')) {
      api.createRecord('e544d26e', component.options)
    } else {
      api.reload('e544d26e', component.options)
    }
    module.hot.accept("./w2d.vue?vue&type=template&id=e544d26e&", function () {
      api.rerender('e544d26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/w2d.vue"
export default component.exports